import React from 'react';
import LegalPage, { LegalSection as Section } from '../components/LegalPage';

const Terms = () => (
  <LegalPage
    title="Terms of Service"
    description="WASLX terms of service — acceptable use, beta period, data ownership, intellectual property, liability, and governing law. Read before using the platform."
    path="/terms"
    heading="Terms of Service"
    updated="April 27, 2025"
  >
    <>
        <Section title="1. Acceptance of terms">
          <p>By accessing or using WASLX ("Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>
          <p>These terms apply to all users, including administrators, supervisors, and agents.</p>
        </Section>

        <Section title="2. Description of service">
          <p>WASLX is a mobile-first call center platform that enables organisations to conduct outbound calling campaigns using Android smartphones. Features include auto dialing, lead management, live monitoring, campaign management, and reporting.</p>
        </Section>

        <Section title="3. Beta period">
          <p>WASLX is currently in beta. During the beta period:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>The Service is provided free of charge for the first 30 days from sign-up.</li>
            <li>Features may change, be added, or be removed without prior notice.</li>
            <li>We will notify you before the beta period ends and present our paid plan options.</li>
            <li>No automatic charges will be applied after the beta period without your explicit consent.</li>
          </ul>
        </Section>

        <Section title="4. Acceptable use">
          <p>You agree to use WASLX only for lawful purposes. You must not:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Use the platform to make unsolicited calls to numbers on Do Not Call (DNC) registries.</li>
            <li>Violate any applicable telecom, privacy, or data protection laws.</li>
            <li>Use the platform to harass, threaten, or defraud called parties.</li>
            <li>Attempt to reverse-engineer, copy, or resell any part of WASLX.</li>
            <li>Upload malicious files or attempt to disrupt the platform.</li>
          </ul>
          <p>You are solely responsible for ensuring your calling operations comply with local laws, including obtaining required consents for call recordings.</p>
        </Section>

        <Section title="5. Data and privacy">
          <p>Your use of WASLX is subject to our Privacy Policy. You retain ownership of your lead data. We process it only to provide the Service as described.</p>
        </Section>

        <Section title="6. Availability and SLA">
          <p>We aim for high availability but do not guarantee uninterrupted service. During the beta period, there is no formal SLA. We will communicate planned maintenance in advance where possible.</p>
        </Section>

        <Section title="7. Intellectual property">
          <p>WASLX and its underlying technology are owned by us. Your use of the Service does not grant you any ownership rights. You may not copy, modify, or distribute the WASLX platform or documentation without written permission.</p>
        </Section>

        <Section title="8. Limitation of liability">
          <p>To the maximum extent permitted by law, WASLX shall not be liable for indirect, incidental, or consequential damages arising from your use of the Service. Our total liability shall not exceed the amount paid by you in the three months prior to the claim.</p>
        </Section>

        <Section title="9. Termination">
          <p>Either party may terminate at any time. On termination, your access will be revoked. We will retain your data for 30 days following termination and then delete it, unless required by law to retain longer.</p>
        </Section>

        <Section title="10. Governing law">
          <p>These terms are governed by the laws of India. Disputes shall be subject to the exclusive jurisdiction of courts in India.</p>
        </Section>

        <Section title="11. Changes to terms">
          <p>We may update these terms from time to time. We will notify you by email. Continued use of the Service after changes constitutes acceptance.</p>
        </Section>

        <Section title="12. Contact">
          <p>Questions about these terms? Email <strong>hello@waslx.co.in</strong>.</p>
        </Section>
    </>
  </LegalPage>
);

export default Terms;
